import { eTraTienSinhVienActionsObj } from "../../action-types/bao-cao/ITraTienSinhVienActions";
import { generateActions } from "../generateActions";

export const traTienSinhVienActions = {
  ...generateActions(eTraTienSinhVienActionsObj, "TRA_TIEN_SINH_VIEN"),
};
